module.exports = __webpack_public_path__ + "static/media/b0_p12_clickable.6e9ab6ff.mp3";